@if (authService.isAuthenticated()) {
@if (isAdminRoute()) {
<router-outlet></router-outlet>
} @else {
<div class="min-h-screen flex flex-col bg-background">
  <header class="bg-card shadow-md border-b border-border sticky top-0 z-50">
    <nav class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <a routerLink="/client/dashboard" title="Go to dashboard" class="flex-shrink-0 flex items-center gap-3">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/arrisfinance.firebasestorage.app/o/arris-finance-logo.png?alt=media&token=89c9b8b6-0ce4-4b08-b042-a6dc49400690"
              alt="Arris Finance Logo" class="h-10 w-auto">
            <div class="flex flex-col leading-none">
              <span class="text-xl text-foreground font-cal-sans">Arris</span>
              <span class="text-xl text-foreground -mt-1 font-cal-sans">Finance</span>
            </div>
          </a>
          @if(authService.userProfile(); as profile) {
          <span
            class="hidden sm:inline-block text-sm text-muted-foreground font-medium ml-6 pl-6 border-l border-border">{{
            profile.role === 'Admin' ? 'Admin' : 'Client' }} Portal</span>
          @if(actingContext.isActingForAnother()) {
          <span
            class="hidden sm:inline-flex items-center gap-2 ml-4 px-3 py-1 bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 text-xs font-semibold rounded-full">
            <i class="fa-solid fa-user-shield"></i>
            <span>Viewing as: {{ actingContext.actingForClient()?.displayName }}</span>
            <button (click)="clearActingAndNavigate()" class="ml-1 hover:text-blue-900 dark:hover:text-blue-200">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </span>
          }
          }
          @if(authService.userProfile()?.role === 'Client') {
          <div class="hidden md:block">
            <div class="ml-12 flex items-center space-x-1">
              @for(item of clientNavItems(); track item.path) {
              <a [routerLink]="item.path" routerLinkActive="bg-accent text-accent-foreground"
                [routerLinkActiveOptions]="{exact: item.path === '/client/dashboard'}"
                class="text-foreground hover:bg-muted px-3 py-2 rounded-md text-sm font-medium">
                {{item.label}}
              </a>
              }
            </div>
          </div>
          }
        </div>
        <div class="hidden md:flex items-center space-x-4">
          @if(authService.userProfile(); as profile) {
          @if (profile.role === 'Client') {
          <span class="text-foreground text-sm font-medium hidden sm:block">Welcome, {{ profile.displayName ||
            profile.email }}</span>
          }
          }

          <!-- Notification Bell -->
          @if (authService.userProfile()?.role === 'Client') {
          <div class="relative">
            <button (click)="showNotifications.set(!showNotifications())"
              class="relative w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground rounded-full text-sm font-medium transition-colors">
              <i class="fa-regular fa-bell text-xl"></i>
              @if (unreadNotifications().length > 0) {
              <span class="absolute top-1.5 right-1.5 flex h-2.5 w-2.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
              </span>
              }
            </button>

            @if(showNotifications()) {
            <!-- Backdrop -->
            <div (click)="showNotifications.set(false)" class="fixed inset-0 z-40"></div>

            <!-- Dropdown Panel -->
            <div
              class="absolute right-0 mt-2 w-80 sm:w-96 bg-popover rounded-lg shadow-2xl border border-border z-50 overflow-hidden">
              <div class="p-3 flex justify-between items-center border-b border-border">
                <h3 class="font-semibold text-popover-foreground">Notifications</h3>
                @if (unreadNotifications().length > 0) {
                <button (click)="markAllAsRead()"
                  class="text-xs text-[#007ea7] dark:text-[#64c3ce] hover:underline">Mark all as read</button>
                }
              </div>
              <div class="max-h-96 overflow-y-auto">
                @for(notification of unreadNotifications(); track notification.id) {
                <div (click)="onNotificationClick(notification)"
                  [class]="'p-3 flex items-start gap-3 hover:bg-muted cursor-pointer border-b border-border transition-colors ' + getPriorityClass(notification.priority)">
                  <div class="flex-shrink-0 mt-1 text-2xl">
                    {{ getNotificationIcon(notification.type) }}
                  </div>
                  <div class="flex-grow">
                    <p class="text-sm text-popover-foreground font-medium">{{ notification.message }}</p>
                    <div class="flex items-center gap-2 mt-1">
                      <p class="text-xs text-muted-foreground">{{ notification.dealName }}</p>
                      @if (notification.priority === 'HIGH') {
                      <span class="text-xs font-semibold text-red-600 dark:text-red-400">URGENT</span>
                      }
                    </div>
                    <p class="text-xs text-muted-foreground mt-0.5">
                      {{ notification.timestamp | date:'short' }}
                    </p>
                  </div>
                </div>
                } @empty {
                <div class="p-6 text-center">
                  <p class="text-sm text-muted-foreground">You have no new notifications.</p>
                </div>
                }
              </div>
              <div class="p-3 border-t border-border">
                <a routerLink="/client/messages" (click)="showNotifications.set(false)"
                  class="block text-center text-sm text-[#007ea7] dark:text-[#64c3ce] hover:underline font-medium">
                  See All Notifications
                </a>
              </div>
            </div>
            }
          </div>
          }

          <button (click)="themeService.toggleTheme()"
            class="w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground rounded-full text-sm font-medium transition-colors">
            @if (themeService.theme() === 'light') {
            <i class="fa-solid fa-moon text-xl"></i>
            } @else {
            <i class="fa-solid fa-sun text-xl"></i>
            }
          </button>
          <button (click)="logout()"
            class="text-muted-foreground hover:text-foreground px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2">
            <i class="fa-solid fa-right-from-bracket text-xl"></i>
            <span class="hidden sm:inline">Logout</span>
          </button>
        </div>
        <!-- Mobile menu button -->
        <div class="flex md:hidden">
          <button (click)="mobileMenuOpen.set(!mobileMenuOpen())" type="button"
            class="bg-card inline-flex items-center justify-center p-2 rounded-md text-muted-foreground hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring"
            aria-controls="mobile-menu" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            @if (!mobileMenuOpen()) {
            <i class="fa-solid fa-bars block h-6 w-6"></i>
            } @else {
            <i class="fa-solid fa-xmark block h-6 w-6"></i>
            }
          </button>
        </div>
      </div>
    </nav>
    <!-- Mobile menu, show/hide based on menu state. -->
    @if (mobileMenuOpen() && authService.userProfile()?.role === 'Client') {
    <div class="md:hidden" id="mobile-menu">
      @if(actingContext.isActingForAnother()) {
      <div class="px-2 pt-2 pb-2">
        <div
          class="flex items-center justify-between gap-2 px-3 py-2 bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 text-sm font-semibold rounded-lg">
          <div class="flex items-center gap-2">
            <i class="fa-solid fa-user-shield"></i>
            <span>Viewing as: {{ actingContext.actingForClient()?.displayName }}</span>
          </div>
          <button (click)="clearActingAndNavigate()" class="hover:text-blue-900 dark:hover:text-blue-200">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
      }
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        @for(item of clientNavItems(); track item.path) {
        <a [routerLink]="item.path" (click)="mobileMenuOpen.set(false)"
          routerLinkActive="bg-accent text-accent-foreground"
          [routerLinkActiveOptions]="{exact: item.path === '/client/dashboard'}"
          class="text-foreground hover:bg-muted block px-3 py-2 rounded-md text-base font-medium">
          {{item.label}}
        </a>
        }
      </div>
      <div class="border-t border-border"></div>
      <div class="py-2 px-2 sm:px-3">
        <button (click)="logout()"
          class="w-full flex items-center gap-3 text-muted-foreground hover:bg-muted hover:text-foreground px-3 py-2 rounded-md text-base font-medium">
          <i class="fa-solid fa-right-from-bracket text-lg w-5 text-center"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
    }
  </header>
  <main class="flex-grow">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
}
} @else {
<router-outlet></router-outlet>
}
<app-toast></app-toast>
